<template>
  <div>
    <v-card color="grey lighten-4 my-3">
      <v-toolbar dense>
        <v-toolbar-title>Menunggu Pembayaran</v-toolbar-title>

        <v-spacer></v-spacer>
        <div class="pa-5">
          <v-text-field
            flat
            dense
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="hidden-sm-and-down"
          />
        </div>
      </v-toolbar>
    </v-card>
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">No. Invoice</th>
            <th class="text-left">Nominal</th>
            <th class="text-left">Nomor VA</th>
            <th class="text-left">Status</th>
            <!-- <th class="text-left">Aksi</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in dataPending" :key="item.Nominal">
            <td>{{ item.No_Invoice }}</td>
            <td>{{ item.Nominal | currency}}</td>
            <td>{{ item.Virtual_Account }}</td>
            <td>{{item.Status}}</td>

            <td>
              <!-- <v-btn @click="click(item.id)" text small color="primary">Bayar</v-btn> -->
              <!-- <v-btn @click="detail_invoice(item.Pesanan)" text small color="primary">Detail</v-btn> -->
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <!-- DIALOG -->
    <v-dialog v-model="sel_invoice" width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Detail
          <v-spacer></v-spacer>
          <v-btn @click="sel_invoice = false" icon color="#90A4AE">
            <v-icon>fas fa-times-circle</v-icon>
          </v-btn>
        </v-card-title>

        <v-simple-table fixed-header height="300px">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Gambar</th>
                <th class="text-left">Nama</th>
                <th class="text-left">Qty</th>
                <th class="text-left">Ongkir</th>
                <th class="text-left">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in detail" :key="item.id">
                <td>
                  <div>
                    <v-avatar tile>
                      <img :src="getImageUrl(item.Gambar)" alt="John" />
                    </v-avatar>
                  </div>
                </td>
                <td>
                  <b>{{item.Nama}}</b>
                </td>
                <td>{{item.Qty}}</td>
                <td>{{item.Ongkir | currency}}Kg</td>
                <td>{{item.SubTotal | currency}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>

        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="sel_invoice = false">I accept</v-btn>
        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sel_invoice: false,
      test: 1016,
      userid: localStorage.getItem("user_id"),
      token: localStorage.getItem("token"),
      detail: null,
      dataPending: []
    };
  },
  mounted() {
    this.PendingTrans();
  },
  methods: {
    click(e) {
      alert(e);
    },
    PendingTrans() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/penerima/" +
          this.userid +
          "/pending"
      )
        .then(response => response.json())
        .then(data => {
          this.dataPending = data;
        });
    },
    detail_invoice(data) {
      this.sel_invoice = true;
      this.detail = data;
    },
    getImageUrl(e) {
      var x = e.replace(/\.[^/.]+$/, "");
      return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
    }
  }
};
</script>